module.exports = __webpack_public_path__ + "static/media/yasmeen.e7664b55.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/yasmeen.JPG
// module id = 569
// module chunks = 0